export default {
  info: {
    id: 'maintenanceMode.info',
    defaultMessage: 'The app is currently undergoing maintenance. Please check back soon.',
  },
};
